// @flow
import React, { Component } from 'react';
import { DescriptionWrapperDiv } from './CryptoWalletsStyles';

type Props = {};

export default class Description extends Component<Props> {
  render() {
    return (
      <DescriptionWrapperDiv>
        <p>
          Please add your external crypto wallet adresses below so that we can
          send you the commission payouts.
          <strong>
            {' '}
            If you don’t add an external wallet then we have no way of sending
            you the funds accumulated.
          </strong>
        </p>
      </DescriptionWrapperDiv>
    );
  }
}
